import { StorageState } from '../types/storage';
import loggerService, { LoggerLevel } from '../../log';

/**
 * Get current storage estimate from Navigator Storage API.
 * Returns undefined values if API is not supported or fails.
 *
 * @returns StorageState with current storage information
 */
export const getStorageEstimate = async (): Promise<StorageState> => {
  try {
    if ('storage' in navigator && 'estimate' in navigator.storage) {
      const estimate = await navigator.storage.estimate();
      const { quota, usage } = estimate;

      // Both quota and usage must be defined to calculate available storage
      // The browser API can return undefined for these values in certain scenarios
      let available = undefined;

      if (quota != null && usage != null) {
        available = quota - usage;
      }

      return {
        quota,
        usage,
        available,
        lastUpdated: Date.now(),
      };
    } else {
      // Storage API not supported
      return {
        lastUpdated: Date.now(),
      };
    }
  } catch (error) {
    loggerService.log(LoggerLevel.ERROR, 'Failed to get storage estimate:', error);
    return {
      lastUpdated: Date.now(),
    };
  }
};
